module.exports = __webpack_public_path__ + "static/media/rec_05073493318_01062064378_20200323152710.b860de86.wav";